import { render, staticRenderFns } from "./AllNotificationsModal.vue?vue&type=template&id=0ab8aaa0"
import script from "./AllNotificationsModal.vue?vue&type=script&lang=js"
export * from "./AllNotificationsModal.vue?vue&type=script&lang=js"
import style0 from "./AllNotificationsModal.vue?vue&type=style&index=0&id=0ab8aaa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports